import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { ArrowLeft, Plus, Edit, Trash2 } from 'lucide-react';
import api, { isAuthenticated } from '../utils/api';
import { toast } from 'sonner';

const AdminBlogsPage = () => {
  const [blogs, setBlogs] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [formData, setFormData] = useState({ title: '', slug: '', content: '', category: 'general', author: 'Ahmedabad NX', thumbnail: '', meta_title: '', meta_description: '', published: true });
  const navigate = useNavigate();

  useEffect(() => { if (!isAuthenticated()) { navigate('/admin/login'); return; } fetchBlogs(); }, []);
  const fetchBlogs = async () => { try { const r = await api.get('/blogs'); setBlogs(r.data); } catch(e){} };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editing) await api.put(`/blogs/${editing.slug}`, formData);
      else await api.post('/blogs', formData);
      toast.success('Saved!');
      setShowForm(false); setEditing(null);
      setFormData({ title: '', slug: '', content: '', category: 'general', author: 'Ahmedabad NX', thumbnail: '', meta_title: '', meta_description: '', published: true });
      fetchBlogs();
    } catch (e) { toast.error('Error'); }
  };

  const handleDelete = async (slug) => {
    if (!window.confirm('Delete?')) return;
    try { await api.delete(`/blogs/${slug}`); toast.success('Deleted'); fetchBlogs(); } catch(e) { toast.error('Error'); }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b sticky top-0 z-50">
        <div className="px-6 py-4 flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <Link to="/admin/dashboard" className="text-[#E5A93C]"><ArrowLeft className="w-6 h-6" /></Link>
            <h1 className="font-heading text-xl font-bold text-[#2A0000]">Blog Management</h1>
          </div>
          <button onClick={() => { setShowForm(true); setEditing(null); }} className="btn-primary flex items-center space-x-2"><Plus className="w-5 h-5" /><span>New Blog</span></button>
        </div>
      </header>

      <div className="p-6">
        {showForm && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto p-6">
              <h2 className="text-2xl font-bold mb-6">{editing ? 'Edit' : 'New'} Blog</h2>
              <form onSubmit={handleSubmit} className="space-y-4">
                <input type="text" placeholder="Title" value={formData.title} onChange={(e) => setFormData({ ...formData, title: e.target.value, slug: e.target.value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') })} required className="w-full px-4 py-2 border rounded" />
                <input type="text" placeholder="Slug" value={formData.slug} onChange={(e) => setFormData({ ...formData, slug: e.target.value })} required className="w-full px-4 py-2 border rounded" />
                <input type="text" placeholder="Thumbnail URL" value={formData.thumbnail} onChange={(e) => setFormData({ ...formData, thumbnail: e.target.value })} className="w-full px-4 py-2 border rounded" />
                <textarea placeholder="Content" value={formData.content} onChange={(e) => setFormData({ ...formData, content: e.target.value })} rows={10} required className="w-full px-4 py-2 border rounded" />
                <div className="grid grid-cols-2 gap-4">
                  <select value={formData.category} onChange={(e) => setFormData({ ...formData, category: e.target.value })} className="px-4 py-2 border rounded">
                    <option value="general">General</option><option value="style-tips">Style Tips</option><option value="bridal-guides">Bridal Guides</option><option value="festive-fashion">Festive Fashion</option><option value="care-tips">Care Tips</option>
                  </select>
                  <label className="flex items-center space-x-2"><input type="checkbox" checked={formData.published} onChange={(e) => setFormData({ ...formData, published: e.target.checked })} /><span>Published</span></label>
                </div>
                <div className="flex space-x-2">
                  <button type="submit" className="flex-1 btn-primary">Save</button>
                  <button type="button" onClick={() => setShowForm(false)} className="flex-1 btn-outline">Cancel</button>
                </div>
              </form>
            </div>
          </div>
        )}

        <div className="bg-white rounded-lg border">
          <table className="w-full">
            <thead className="bg-gray-50 border-b"><tr><th className="px-6 py-3 text-left text-xs uppercase">Title</th><th className="px-6 py-3 text-left text-xs uppercase">Category</th><th className="px-6 py-3 text-left text-xs uppercase">Status</th><th className="px-6 py-3 text-left text-xs uppercase">Actions</th></tr></thead>
            <tbody className="divide-y">
              {blogs.map(b => (
                <tr key={b.slug}>
                  <td className="px-6 py-4 font-medium">{b.title}</td>
                  <td className="px-6 py-4 text-gray-600">{b.category}</td>
                  <td className="px-6 py-4"><span className={`px-2 py-1 text-xs rounded ${b.published ? 'bg-green-100 text-green-800' : 'bg-gray-100'}`}>{b.published ? 'Published' : 'Draft'}</span></td>
                  <td className="px-6 py-4 flex space-x-2">
                    <button onClick={() => { setEditing(b); setFormData(b); setShowForm(true); }}><Edit className="w-5 h-5 text-blue-600" /></button>
                    <button onClick={() => handleDelete(b.slug)}><Trash2 className="w-5 h-5 text-red-600" /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {blogs.length === 0 && <p className="text-center text-gray-500 p-8">No blog posts yet</p>}
        </div>
      </div>
    </div>
  );
};

export default AdminBlogsPage;
